import React from 'react';
import { Create } from 'react-admin';

import PriorizacionForm from '../PriorizacionForm';

function PriorizacionCreate({ ...props }) {
  return (
    <Create {...props}>
      <PriorizacionForm redirect="list" />
    </Create>
  );
}

export default PriorizacionCreate;
